import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { NextArrow, PrevArrow } from "../Shared";

import TourListItem from "../TourListItem";

export default function SimilarToursCarousel({
    tours: data,
    specific_tours,
    sliderSettings = {},
    headerClass,
    containerMargin = "mt-5",
}) {
    // console.log("similar tours", data);

    const Arrow = ({ onClick = (f) => f, direction = "right" }) => {
        return (
            <button
                onClick={onClick}
                className="btn btn-secondary d-flex justify-content-center align-items-center"
                style={{
                    position: "absolute",
                    top: "50%",
                    right: direction == "right" ? "-40px" : "auto",
                    left: direction == "left" ? "-40px" : "auto",
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                }}
            >
                <i
                    className={`fa ${
                        direction == "right"
                            ? "fa-chevron-right"
                            : "fa-chevron-left"
                    }`}
                ></i>
            </button>
        );
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <Arrow direction="right" />,
        prevArrow: <Arrow direction="left" />,
        ...sliderSettings,
    };

    return (
        <div className={containerMargin}>
            <h3 className={"body-font font-weight-bold mb-2 " + headerClass}>
                You might also like...
            </h3>
            <Slider {...settings}>
                {data.map((tourData, i) => (
                    <div key={i} className="px-1" style={{ maxWidth: "300px" }}>
                        <div className="border" style={{ minHeight: "630px" }}>
                            <TourListItem
                                {...tourData}
                                lazy
                                vertical
                                tourListingCtaText="Learn more"
                                specific_tours={specific_tours}
                            />
                            {/* <div className="col p-4 d-flex justify-content-between mb-3" style={{ marginTop: "-30px" }}>
                                <a className="btn-link primary-text py-2">Learn more &#62;</a>
                                <button className="btn btn-primary btn-rounded px-4 py-2">Add to Cart</button>
                            </div> */}
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}



// WEBPACK FOOTER //
// ./resources/js/components/SimilarToursCarousel/index.js